import type { HistoryToolbarEvent } from "@/features/history/historyEvents";
import { hasLinkModifierKey } from "@/shared/lib/keyboardAccessibility";
import { DesktopSectionToolbar } from "@/shared/ui/navigation/DesktopSectionToolbar";

export interface DesktopHistoryToolbarViewProps {
  mode: "viewed" | "posted";
  isFetching: boolean;
  onEvent: (event: HistoryToolbarEvent) => void;
}

/** カタログと同じ外観で、履歴ページに有効な操作だけを表示する。 */
export function DesktopHistoryToolbarView({
  mode,
  isFetching,
  onEvent,
}: DesktopHistoryToolbarViewProps): React.ReactElement {
  return (
    <DesktopSectionToolbar
      activeDestination={mode === "viewed" ? "history" : undefined}
      ariaLabel="履歴ナビゲーション"
      isFetching={isFetching}
      onRefresh={(): void => onEvent({ type: "history/refresh-requested" })}
      onToggleSidebar={(): void =>
        onEvent({ type: "history/sidebar-toggle-requested" })
      }
      onScrollToTop={(): void =>
        onEvent({ type: "history/scroll-requested", edge: "top" })
      }
      onScrollToBottom={(): void =>
        onEvent({ type: "history/scroll-requested", edge: "bottom" })
      }
      onSettingsClick={(event: React.MouseEvent<HTMLAnchorElement>): void => {
        const hasModifier = hasLinkModifierKey(event);
        if (!hasModifier) event.preventDefault();
        onEvent({ type: "history/settings-link-clicked", hasModifier });
      }}
      secondaryAriaLabel="履歴操作"
    />
  );
}

export function DesktopHistoryToolbar(
  props: DesktopHistoryToolbarViewProps,
): React.ReactElement {
  return <DesktopHistoryToolbarView {...props} />;
}
